module.exports = __webpack_public_path__ + "static/media/error.06251073.svg";